import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { AlmanacFile } from 'types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import type { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export type CrossPostAccount = {
  provider: ExternalIntegrationEnum
  output_type: 'text' | 'design'
  external_integration_id?: number
}

interface Data {
  almanac_files: AlmanacFile[]
}

export interface Variables {
  content: string
  cross_post_accounts: CrossPostAccount[]
  alternative_options?: string[]
  source_type: string
  source_id: string
  cross_post_group_id?: number
}

export const createCrossPosts = async ({ workspaceId, ...body }: Variables & { workspaceId: number }) => {
  const res = await sendToApi<Data>(`/w/${workspaceId}/cross_posts`, {
    method: 'POST',
    body: { workspace: workspaceId, ...body },
  })

  if (res.type === 'exception' && res.data instanceof DOMException && res.data.name === 'AbortError') {
    throw res.data
  }
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    if (res.data === 'cancel') throw new DOMException('The operation was aborted.', 'AbortError')
    throw new Error(res.data)
  }
  return res.data
}

export const useCreateCrossPosts = (options?: Omit<Parameters<typeof useMutation>[2], 'mutationFn'>) => {
  const workspaceId = useCurrentWorkspaceId()

  return useMutation<AlmanacFile[], Error, Variables>(
    (vars) => createCrossPosts({ workspaceId, ...vars }).then((r) => r.almanac_files),
    options,
  )
}
